import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'app-wrapper',
    host: {
        '[style.max-width]': 'this.computedMaxWidth()',
    },
    template: `<ng-content></ng-content>`,
    styles: [
        ':host {display: block; margin: 0 auto; padding-left: 1rem; padding-right: 1rem;}',
    ],
    standalone: false
})
export class WrapperComponent {
  maxWidth = input<string>('1366px');

  //To ensure the content within the wrapper takes up the desired width, add the padding to the input value
  computedMaxWidth = computed(() =>
    (parseInt(this.maxWidth().replace('px', '')) + 32).toString().concat('px')
  );

  constructor() {}
}
